module.exports = __webpack_public_path__ + "static/media/AthenianArcher.cfa5a851.jpg";